<template>
  <div class="remove-user-popup">
    <template v-if="!isShowSuccessMsg">
      <div class="h2">Вы действительно <br /> хотите удалить аккаунт?</div>
      <span class="attention-message">При удалении аккаунта безвозвратно будут удалены ваши товары из корзины и избранного, а так же будет удалена вся информация из профиля</span>
      <button
        class="remove-btn btn btn-primary btn-big"
        :class="{'--loading': isFormSending}"
        @click="onConfirmRemove"
      >
        Удалить аккаунт
      </button>
      <div
        class="not-remove attention-message"
        @click="emits('closeModal')"
      >
        Не удалять акканут
      </div>
    </template>

    <template v-else>
      <div class="h2">Заявка принята</div>
      <span class="attention-message">Запрос на удаление аккаунта успешно сформирован.<br/>Аккаунт будет удален в течение 1 рабочего дня.</span>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { IUser } from '#sitis/internal/controllers/user/models/User';
import { errorParserServerResponse } from '~/utils/errorParserServerResponse';
import { useCommonStore } from '~/store/common';

const { $api, $toast } = useNuxtApp();
const isFormSending = ref(false);
const isShowSuccessMsg = ref(false);

const props = defineProps<{
	currentUser: IUser | null;
}>();

const emits = defineEmits<{
	closeModal: [];
}>();

async function onConfirmRemove () {
  if (isFormSending.value) {
    return
  }
  isFormSending.value = true;

  let newForm: { [key: string]: any } = {
    nophone: 1,
    message: '',
    type: 'Заявка на удаление аккаунта'
  };
  if (props?.currentUser?.email) {
    newForm.email = props?.currentUser?.email;
  }
  if (props?.currentUser?.phone) {
    newForm.phone = props?.currentUser?.phone;
  }

  newForm.message = `Внимание! Запрос на удаление данных - от пользователья ${props.currentUser?.username}`;

  const response = await $api.agent.post('/form/send', { body: { ...newForm } })
    .then((res) => res._data)
    .catch((err) => ({ error: errorParserServerResponse(err.response) }));

  if (response.error) {
    $toast.error(response.error);
    isFormSending.value = false;
    return false;
  }

  isShowSuccessMsg.value = true;
  isFormSending.value = false;
}
</script>

<style scoped lang="scss">
.remove-user-popup {
	& .attention-message {
		color: var(--silver);
		font-size: 16px;
		font-weight: 600;
		line-height: 22px;
		text-align: left;
		margin-bottom: 24px;
		display: block;
	}

	& .not-remove {
		text-align: center;
		margin-bottom: 0;
		cursor: pointer;
	}

	& .remove-btn {
		width: 100%;
		margin-bottom: 24px;
	}
}
</style>
